import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/itch-io': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M71.9 34.8c19.2-1.7 114.3-2.8 184.1-2.8s116.6 0.4 184 2.7c21.7 12.9 64.5 62.1 64.9 75v21.3c0 27.1-25.3 50.8-48.3 50.8-27.5 0-50.5-22.9-50.5-50 0 27.1-22.2 50-49.8 50s-49-22.9-49-50c0 27.1-23.6 50-51.2 50h-0.5c-27.6 0-51.2-22.9-51.2-50 0 27.1-21.4 50-49 50s-49.8-22.9-49.8-50c0 27.1-23 50-50.5 50-23 0-48.3-23.8-48.3-50.8v-21.3c0.4-12.9 43.2-62.1 64.9-75zM204.2 169.2c9.1 16 31.6 29 50 29 0.5 0 1.3 0 1.8 0 28.7 0 44.7-16.5 51.8-28.9 22 38.3 77.8 38.8 99.8 0.2 13.1 23.1 43.1 32.1 56 27.7 3.6 37.1 13.9 236.9-17.8 269.1-77.7 18.1-299.8 18.7-379.8 0-31.4-32-21.6-229-17.7-269.1 12.8 4.4 42.8-4.5 56-27.7 22 38.5 77.9 38.1 99.9-0.3zM162.7 222.9l0 0.1c-52.3 0-65.2 77.5-83.9 144.4-17.3 62.1 5.5 63.7 33.9 63.7 42.1-1.6 65.5-32.2 65.5-62.8 53.6 8.8 116.3 6.4 155.6 0 0 30.6 23.3 61.2 65.5 62.8 28.4-0.1 51.2-1.6 33.9-63.7-18.6-66.9-31.5-144.4-83.9-144.4-16.5 0-31.1 0-49.3 19.7-12.1-1.2-31.9-2.2-44.1-2.2-12.2 0-32 1-44.1 2.2-18.1-19.8-32.8-19.8-49.2-19.8zM256 270.8l-0.1 0s44.3 40.8 52.3 55.2l-29-1.2v25.3c0 1.2-11.7 0.7-23.3 0.2-2 0-23.3 1.4-23.3-0.2v-25.3l-29 1.2c8-14.4 52.3-55.2 52.3-55.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/itch-io.js
// module id = 891
// module chunks = 0